import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUser } from '../pages/getUserDB';
import Loading from '../components/Loading';
import AppTheme from '../shared-theme/AppTheme';
import { Button, Container, Typography } from '@mui/material';
import logoCabanaWhite from '../images/logonextcabana-white.svg';

export function InactiveRoute(
  { children }: { children: React.ReactNode },
  props: { disableCustomTheme?: boolean }
) {
  const [isAcitve, setIsActive] = useState<boolean | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const dataUser = async () => {
      const data = await getUser();
      data.status === 'ativo' ? setIsActive(true) : setIsActive(false);
    }
    dataUser();
  }, []);

  if (isAcitve === false) {
    return (
      <AppTheme {...props}>
        <Container
          component="main"
          sx={{
            maxWidth: 'xs',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            gap: 2
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '40px',
              marginBottom: '40px'
            }}
          >
            <img
              src={logoCabanaWhite}
              alt="logo-cabanalink"
              style={{ width: '300px', height: 'auto' }}
            />
          </div>
          <Typography variant="h5">Área exclusiva para usuários ativos.</Typography>
          <Button
            onClick={() => navigate('/payment')}
            variant="contained"
            sx={{ width: '250px', alignSelf: 'center' }}
          >
            Regularize seu pagamento
          </Button>
        </Container>
      </AppTheme>
    );
  }

  if (isAcitve === null) {
    return (
      <Loading />
    )
  }


  return <>{children}</>;
}
